// Single source of truth for studio metadata, contact info, and the
// primary nav. Anything that shows up in more than one place lives
// here so we change it once.

export const site = {
  name: "UPSHOT",
  fullName: "UPSHOT Architecture",
  tagline: "Thoughtful Design. Lasting Impact.",
  city: "Bozeman, Montana",
  email: "sten@upshotarch.com",
  phone: "(406) 599-1372",
  phoneTel: "+14065991372",
  founded: 2020,
  principal: "Sten Witmer, Architect",
  shortBio:
    "A Bozeman, Montana studio focused on contemporary residential and commercial architecture — buildings designed for permanence, integrated with their site, and detailed by people who have spent time on a job site with a hammer in hand.",
};

export const navItems = [
  { label: "Work", path: "/projects" },
  { label: "Studio", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Contact", path: "/contact" },
];
